import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'gate-landing-layout',
  standalone: true,
  imports: [],
  templateUrl: './landing-layout.component.html',
})
export class LandingLayoutComponent {
  private readonly authService = inject(AuthService);
}
